import {
    ResponsiveImage,
    ResponsiveImageVariant
} from "@omni/types/components/image/responsiveImage.type";
import { ModelMapper } from "@omni/types/utils/modelMapper";

import {
    getFrontEndImage,
    MediaSettings
} from "./helpers/frontEndImage.helpers";

type SeperateModelParams = {
    lazyLoading: boolean;
    image?: ResponsiveImage<ResponsiveImageVariant.Core>;
    mobileImage?: ResponsiveImage<ResponsiveImageVariant.Core>;
};

const getEmptyImageSrc = (width: string | null, height: string | null) => {
    if (!width || !height) {
        return "";
    }

    const svg = `<?xml version="1.0" encoding="UTF-8" ?><svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 ${width} ${height}"><rect x="0" y="0" width="10" height="10" style="fill:white;fill-opacity:0" /></svg>`;
    const base64 = btoa(svg);

    return `data:image/svg+xml;base64,${base64}`;
};
const fromCoreToFrontEnd: ModelMapper<
    SeperateModelParams,
    ResponsiveImage<ResponsiveImageVariant.FrontEnd> | undefined
> = ({ image, mobileImage, lazyLoading }) => {
    const desktopFrontEndImage = getFrontEndImage({
        image,
        mediaSettings: null
    });

    if (!desktopFrontEndImage) {
        return undefined;
    }

    const mobileFrontEndImage = getFrontEndImage({
        image: mobileImage,
        mediaSettings: MediaSettings.Mobile
    });

    return {
        alt: image?.altText || "",
        lazyLoading,
        src:
            image?.src ??
            getEmptyImageSrc(
                desktopFrontEndImage.width,
                desktopFrontEndImage.height
            ) ??
            "",
        desktop: desktopFrontEndImage,
        mobile: mobileFrontEndImage
    } satisfies ResponsiveImage<ResponsiveImageVariant.FrontEnd>;
};

export const ResponsiveImageMapper = {
    fromCoreToFrontEnd
};
